module.exports = __webpack_public_path__ + "static/carnival-corp-logo-549a0a13f289a84dc2529d4551957272.svg";